import { mapActions } from 'vuex';

import { PRODUCTS_ORDER_KEY, PRODUCTS_VIEW_TYPE } from '@/helpers';
import { MEDIA } from '@/helpers/variables';
import IconList from '@/components/icons/IconList.vue';
import IconGrid from '@/components/icons/IconGrid.vue';

export default {
  name: 'ProductsTogglerType',
  components: {
    IconGrid,
    IconList
  },
  props: {
    viewType: {
      type: String,
      default: PRODUCTS_VIEW_TYPE.GRID
    }
  },
  emits: ['change-view'],
  data() {
    return {
      MEDIA,
      PRODUCTS_VIEW_TYPE,
      sortType: PRODUCTS_ORDER_KEY.BESTSELLERS
    };
  },

  created() {},
  computed: {},
  methods: {
    ...mapActions({}),
    onChangeProductsView(type) {
      this.$emit('change-view', type);
    }
  }
};
